import { FC, memo } from 'react';
import { MobileStore } from '../../../../types';
import { useMobileAppInfo } from '../../utils/use-mobile-app-info';
import { QrContainer, QrCode, StoreBadge } from './qr-store.styled';

type MobileAppQrProps = {
  store: MobileStore;
};

export const QrStore: FC<MobileAppQrProps> = memo(({ store }) => {
  const childProps = useMobileAppInfo(store);

  return (
    <QrContainer>
      <QrCode src={childProps.qr} />

      <a href={childProps.link} target="_blank" rel="noopener noreferrer">
        <StoreBadge src={childProps.badge.light} />
      </a>
    </QrContainer>
  );
});
